import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  organizations: [],
  organization: {
    id: 0,
    name: "",
    city: "",
    address: "",
    email: "",
    ra: "",
    countryId: "",
    zipCode: "",
    identifier: ""
  },
  organizationValidation: {
    isValid: true,
    name: {
      isValid: true,
      errorMessage: "El campo nombre no debe estar vacio",
    },
    city: {
      isValid: true,
      errorMessage: "El campo ciudad no debe estar vacio",
    },
    email: {
      isValid: true,
      errorMessage: "El campo correo no debe estar vacio",
    },
    ra: {
      isValid: true,
      errorMessage: "El campo ra no debe estar vacio",
    },
    identifier: {
      isValid: true,
      errorMessage: "El campo identificador no debe estar vacio",
    },
    countryId: {
      isValid: true,
      errorMessage: "El campo pais no debe estar vacio",
    },
    zipCode: {
      isValid: true,
      errorMessage: "El campo codigo postal no debe estar vacio",
    },
    address: {
      isValid: true,
      errorMessage: "El campo dirección no debe estar vacio",
    },
  },
};

const organizationSlice = createSlice({
  name: "organization",
  initialState,
  reducers: {
    restartState(state) {
      state.organization = {};
      state.organizations = [];
    },
    setOrganizations(state, actions) {
      state.organizations = actions.payload.organizations;
      state.organization = {};
    },
    setOrganization(state, actions) {
      state.organization = actions.payload.organization;
      state.organizations = [];
    },
    modifyPropertyValue(state, actions) {
      state.organization[actions.payload.id] = actions.payload.value;
    },
    setOrganizationValidation(state, actions) {
      state.organizationValidation = {
        name: {
          ...state.organizationValidation.name,
          isValid: actions.payload.name !== "",
        },
        identifier: {
          ...state.organizationValidation.identifier,
          isValid: actions.payload.identifier !== "",
        },
        city: {
          ...state.organizationValidation.city,
          isValid: actions.payload.city !== "",
        },
        address: {
          ...state.organizationValidation.address,
          isValid: actions.payload.address !== "",
        },
        email: {
          ...state.organizationValidation.email,
          isValid: actions.payload.email !== "",
        },
        ra: {
          ...state.organizationValidation.ra,
          isValid: actions.payload.ra !== "",
        },
        countryId: {
          ...state.organizationValidation.countryId,
          isValid: actions.payload.countryId !== "",
        },
        zipCode: {
          ...state.organizationValidation.zipCode,
          isValid: actions.payload.zipCode !== "",
        },
      };
      state.organizationValidation.isValid =
        state.organizationValidation.city.isValid;
    },
    setFieldValid(state, actions) {
      state.organizationValidation[actions.payload.id].isValid = actions.payload.value;
    },
  },
});

export const organizationActions = organizationSlice.actions;
export default organizationSlice;
